export default {
	pages: {
		home: '歡迎來到戶外裝備商店！',
		products: '產品',
		interactive: '互動裝備探索器',
		environmental: '我們對環境的承諾',
		cart: '購物車',
		login: '登入',
	},
	interactive_gear_explorer: {
		title: '互動裝備探索器',
		steps: {
			0: '你計劃進行什麼活動？',
			1: '你的預算是多少？',
			2: '這些是我們為你推薦的產品！',
		},
		buttons: {
			hiking: '徒步旅行',
			climbing: '攀岩',
			camping: '露營',
		},
	},
	header: {
		home: '首頁',
		admin: '管理員',
		interactive: '互動裝備探索器',
		environmental: '環境承諾',
		products: '產品',
		cart: '購物車',
		login: '登入',
		logout: '登出',
	},
	product_card: {
		add_to_cart: '加入購物車',
		goto_product: '前往產品',
	},
	environment: {
		title: '我們的環境承諾',
		sustainable_materials: {
			title: '可持續材料',
			description: '我們確保所有材料都來自符合我們嚴格可持續性標準的供應商。',
		},
		energy_efficiency: {
			title: '能源效率',
			description: '我們的製造過程已優化，以最小的能源消耗為目標，旨在減少我們的碳足跡。',
		},
		waste_reduction: {
			title: '減少浪費',
			description: '我們通過回收計劃和設計更長壽命的產品來積極減少浪費。',
		},
		green_packaging: {
			title: '綠色包裝',
			description: '我們正在過渡到可持續的包裝解決方案，旨在最小化使用不可分解的材料。',
		},
		ecological_conservation: {
			title: '生態保護',
			description: '我們支持各種生態保護計劃，致力於保護對我們生存至關重要的自然環境。',
		},
		education_and_collaboration: {
			title: '教育與合作',
			description: '通過教育倡議和合作，我們正在提高環境意識，並在戶外行業內推廣更綠色的實踐。',
		},
	},
	products: {
		title: '我們的產品',
		categories: {
			all: '全部',
			sleeping_bags: '睡袋',
			tents: '帳篷',
			camping_chairs: '露營椅',
			camping_tables: '露營桌',
			portable_lights: '便攜燈',
			stoves: '爐具',
			coolers: '冷卻器',
			tools: '工具',
			backpacks: '背包',
			other: '其他',
			kits: '套件',
			footwear: '鞋類',
			undefined: '未知',
		},
	},
	login: {
		title: '登入',
		emailPlaceholder: '電子郵件',
		passwordPlaceholder: '密碼',
		submit: '登入',
		signup: '我們的商店新來的？',
		signupDescription: '立即註冊以享受獨家福利！',
		signupBenefit: '獲取我們產品的最新消息和更新',
		signupBenefit2: '接收特別優惠和折扣',
	},
	footer: {
		title: '戶外裝備商店',
		menu: {
			title: '菜單',
			home: '首頁',
			products: '產品',
			interactive: '互動裝備探索器',
			environmental: '環境承諾',
			cart: '購物車',
			login: '登入',
		},
		information: {
			title: '資訊',
			about: '關於我們',
			contact: '聯絡我們',
			privacy: '隱私政策',
			terms: '條款與條件',
			careers: '職業',
		},
	},
	home: {
		title: '為戶外活動做好準備',
		products: '探索我們的產品',
		environmental: '我們的環保承諾',
		interactive: '嘗試我們的互動裝備探索器',
	},
	product: {
		title: '產品詳情',
		carbon_footprint: '碳足跡',
		recyclable_materials: '可回收材料',
		end_of_life_options: '產品壽命結束選項',
		add_to_cart: '加入購物車',
	},
};
